module.exports = {
  FichasData: () => {
    return{
      "mg_zs_hybrid_2025": {
        "url_cotiza" : "https://mgcolombia.com/modelos/mg-zs-hybrid/",
        "url_catalog" : require("../assets/datasheets/FICHA_TECNICA_MG_ ZS_HYBRYD+.pdf"),
      },
    }
  }
}